// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {
		const content_submenu = document.querySelector('#content .sub-menu');
		if (content_submenu) {
			const submenu_li = document.querySelector('#content .sub-menu li');
			if (!submenu_li) {
				content_submenu.style.display = 'none';
			}
		}


		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		let home = document.querySelector('body')
		if (home) {
			scrollDownAction(80, 'scroll');
		} else {
			var logoHeader = document.querySelector('.js-scroll-logo img');
			var getLogoUrl;
			var getDataLogo;
			if (logoHeader.length !== 0) {
				getLogoUrl = logoHeader.src || [];
				getDataLogo = logoHeader.getAttribute('data-scroll');
				logoHeader.src = getDataLogo;
			}
		}

		document.querySelector('#burgerMenu').addEventListener('click', function () {
			document.querySelector('.main-nav').classList.add('open');
		});
		document.querySelector('#js-close-menu').addEventListener('click', function () {
			document.querySelector('.main-nav').classList.remove('open');
		});
		document.querySelector('.main-nav__left').addEventListener('click', function () {
			document.querySelector('.main-nav').classList.remove('open');
		});

		document.querySelector('#js-booking').addEventListener('click', function () {
			document.querySelector('.booking').classList.add('open');
		});
		document.querySelector('#js-close-booking').addEventListener('click', function () {
			document.querySelector('.booking').classList.remove('open');
		});
		document.querySelector('.booking__left').addEventListener('click', function () {
			document.querySelector('.booking').classList.remove('open');
		});


		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEle = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEle.length; i++) {
		var viewportOffset = animatedEle[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if (topPos <= window_height * 0.8) {
			animatedEle[i].classList.add('fade-in');
		}
	}
}

/* Accordion */
var accordionItems = document.querySelectorAll('.accordion__item');
var i;
for (i = 0; i < accordionItems.length; i++) {
	let disItem = accordionItems[i];
	let disBtn = disItem.querySelector('.accordion__btn');
	disBtn.addEventListener('click', function(){
		disItem.classList.toggle('open');
	});
}

function getTest(menu_id){
	$.get( `${site_url}ajax/functions.php`, { operation: "getTest", menu_id: menu_id }, function(data){
		$.fancybox(data);
	});
}

function getMenu(menu_id){
	$.get( `${site_url}ajax/functions.php`, { operation: "getMenu", menu_id: menu_id }, 
	function(data){
		$.fancybox(data);
		$('.menu-tabs li').click(function(){
			$('.menu-tabs li').removeClass('active')
			$(this).addClass('active');
			var disMenu = $(this).index();
			$('.menu-view').removeClass('active');
			$('.menu-view:eq(' + disMenu + ')').addClass('active');
		});
	});
}

/* Restaurant menus */
	/* Add prices in titles */
	let catTitles = document.querySelectorAll('.restMenus_cat-title');
	if(catTitles){
		catTitles.forEach( el =>{
			let titletext = el.textContent.split('|');
			if( titletext[1] ){
				el.innerHTML = `${titletext[0]}<span class="titleprice">${titletext[1]}</span>`;
			}else{
				el.innerHTML = `${titletext[0]}`;
			}
		});
	}

	/* Change category format when it have no descriptions nor prices */
	let cats = document.querySelectorAll('.restMenus_cat');
	if(cats){
		cats.forEach( el=>{
			let texts = el.querySelectorAll('.restMenus_prod-text');
			let prices = el.querySelectorAll('.restMenus_prod-price');
			if( ! texts.length && ! prices.length){
				el.classList.add('inline-prods');
			}
		});
	}

	/* List of menus buttons */
	let menuBtns = document.querySelectorAll('.restaurant-menu__menulist-li a');
	if(menuBtns){
		menuBtns.forEach( btn =>{
			btn.addEventListener('click',e=>{
				e.preventDefault();
				let targetMenu = btn.getAttribute("href");
				document.querySelectorAll('.restMenus_item').forEach( menu=>{ menu.classList.remove('active'); });
				document.querySelectorAll('.restaurant-menu__menulist-li a').forEach( btni=>{ btni.classList.remove('active'); }) 
				document.querySelector(targetMenu).classList.add('active');
				btn.classList.add('active');
				$('html, body').animate({
					scrollTop: $(targetMenu).offset().top
					}, 800);
			})
		});
	}

	/* bottom navigation */
	let nextBtn = document.querySelectorAll('.restMenus_arrow-next');
	if(nextBtn){
		nextBtn.forEach( nbtn =>{
			nbtn.addEventListener('click', e=>{
				e.preventDefault();
				let thisMenu = nbtn.closest('.restMenus_item');
				let nextMenu = thisMenu.nextElementSibling;
				if( nextMenu ){
					let nextidSel = `#${ nextMenu.getAttribute('id') }`;
					document.querySelectorAll('.restMenus_item').forEach( menu=>{ menu.classList.remove('active'); });
					var nextmitem = document.querySelector('.restaurant-menu__menulist-li a.active').parentElement.nextElementSibling;
					document.querySelectorAll('.restaurant-menu__menulist-li a').forEach( btni=>{ btni.classList.remove('active'); });
					nextmitem.querySelector('a').classList.add('active');
					nextMenu.classList.add('active');
					$('html, body').animate({
						scrollTop: $(nextidSel).offset().top - 80
						}, 800);
				}
			})
		});
	}
	let prevBtn = document.querySelectorAll('.restMenus_arrow-prev');
	if(prevBtn){
		prevBtn.forEach( nbtn =>{
			nbtn.addEventListener('click', e=>{
				e.preventDefault();
				let thisMenu = nbtn.closest('.restMenus_item');
				let prevMenu = thisMenu.previousElementSibling;
				if( prevMenu && prevMenu.classList.contains('restMenus_item') ){
					let previdSel = `#${ prevMenu.getAttribute('id') }`;
					document.querySelectorAll('.restMenus_item').forEach( menu=>{ menu.classList.remove('active'); });
					var prevmitem = document.querySelector('.restaurant-menu__menulist-li a.active').parentElement.previousElementSibling;
					document.querySelectorAll('.restaurant-menu__menulist-li a').forEach( btni=>{ btni.classList.remove('active'); });
					prevmitem.querySelector('a').classList.add('active');
					prevMenu.classList.add('active');
					$('html, body').animate({
						scrollTop: $(previdSel).offset().top - 80
						}, 800);
				}
			})
		});
	}

/* Shop page */

const shopProducts = document.querySelectorAll('.shop-page__checkbox');
if(shopProducts){
	shopProducts.forEach( el=>{
		el.addEventListener('click', ()=>{
			let padre = el.parentElement;
			if( el.checked == true ){
				padre.querySelector('select').disabled = false;
			}else{
				padre.querySelector('select').disabled = true;
			}
		});
	});
}

$('#deliveryDate').datepicker({
	minDate: +1
});